@if (initialized && dto) {

    <!-- ==================== Tab: Übersicht ==================== -->
    @if (activeNavigationItems?.action == 'overview') {
        <div class="p-3">
            <mvs-crud-object-generic
                [objectType]="'uf.UfFlowTypeStepActivity'"
                [objectId]="objectIdentifier.objectId"
                (onChangedObject)="refreshObject(false)">
            </mvs-crud-object-generic>
        </div>
    }

}
